// Справочник нормативных документов

// src/components/Directory/NormDocuments/NormDocumentsDirectory.js
import React, { useState, useEffect } from 'react';
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CRow,
  CCol,
  CTable,
  CTableHead,
  CTableBody,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
  CSpinner,
  CListGroup,
  CListGroupItem
} from '@coreui/react';
import axios from 'axios';
// Импортируем иконку для кнопки выбора
import { cilCheck } from '@coreui/icons';
import CIcon from '@coreui/icons-react';

const NormDocumentsDirectory = ({ visible, onClose, onSelect }) => { // Добавлен проп onSelect
  const [rootCategories, setRootCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [loadingTree, setLoadingTree] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  // 1. Состояние для отслеживания выбранного документа в таблице
  const [selectedDocument, setSelectedDocument] = useState(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (visible) {
      console.log("Модальное окно открыто, начинаем загрузку корневых категорий.");
      loadRootCategories();
      // Сброс выбранного документа при открытии
      setSelectedDocument(null);
    } else {
      console.log("Модальное окно закрыто, сбрасываем данные.");
      setRootCategories([]);
      setSelectedCategory(null);
      setDocuments([]);
      setSelectedDocument(null); // Сброс при закрытии
    }
  }, [visible]);

  useEffect(() => {
    if (selectedCategory) {
      console.log(`Выбрана категория: ${selectedCategory.Name} (ID: ${selectedCategory.Id}), загружаем документы.`);
      loadDocuments(selectedCategory.Id);
      // Сброс выбранного документа при смене категории
      setSelectedDocument(null);
    } else {
      console.log("Категория не выбрана, очищаем таблицу документов.");
      setDocuments([]);
      setSelectedDocument(null); // Сброс при смене категории
    }
  }, [selectedCategory]);

  const loadRootCategories = async () => {
    setLoadingTree(true);
    console.log("Отправка запроса за корневыми категориями...");
    try {
      const response = await axios.get(`/api/typetable/`, {
        params: {
          ntype: 103,
          id_parent: 0,
          table: 'typetable'
        },
        headers: { Authorization: `Bearer ${token}` }
      });

      console.log("Полный ответ API (корневые категории):", response);
      console.log("Данные из ответа (корневые категории):", response.data);

      if (Array.isArray(response.data)) {
        const categories = response.data;
        setRootCategories(categories);
        if (categories.length > 0) {
          console.log("Автоматически выбираем первую категорию:", categories[0]);
          setSelectedCategory(categories[0]);
        } else {
          console.log("Корневые категории не найдены.");
        }
      } else {
        console.warn("Неожиданный формат данных для корневых категорий или пустой ответ:", response.data);
        setRootCategories([]);
      }
    } catch (error) {
      console.error("Ошибка загрузки корневых категорий:", error);
      if (error.response) {
        console.error("Данные ошибки от сервера:", error.response.data);
        console.error("Статус ошибки:", error.response.status);
        alert(`Ошибка ${error.response.status} при загрузке списка категорий: ${error.response.data?.message || error.response.data || 'Неизвестная ошибка сервера'}`);
      } else if (error.request) {
        console.error("Запрос отправлен, но ответ не получен:", error.request);
        alert("Ошибка сети: Не удалось получить ответ от сервера при загрузке категорий. Проверьте подключение и доступность API.");
      } else {
        console.error("Ошибка настройки запроса:", error.message);
        alert("Ошибка при настройке запроса категорий: " + error.message);
      }
      setRootCategories([]);
    } finally {
      setLoadingTree(false);
    }
  };

  const loadDocuments = async (parentId) => {
    setLoadingTable(true);
    setDocuments([]);
    console.log(`Отправка запроса за документами для категории ID ${parentId}...`);
    try {
      const response = await axios.get(`/api/typetable/`, {
        params: {
          ntype: 87,
          id_parent: parentId,
          table: 'typetable'
        },
        headers: { Authorization: `Bearer ${token}` }
      });

      console.log(`Полный ответ API (документы для ID ${parentId}):`, response);
      console.log(`Данные из ответа (документы для ID ${parentId}):`, response.data);

      if (Array.isArray(response.data)) {
        const rawData = response.data;
        const adaptedData = rawData.map(item => ({
          id: item.Id,
          name: item.Name,
          year: item.Field1
        }));
        console.log(`Адаптированные данные документов для ID ${parentId}:`, adaptedData);
        setDocuments(adaptedData);
      } else {
        console.warn(`Неожиданный формат данных для документов категории ID ${parentId} или пустой ответ:`, response.data);
        setDocuments([]);
      }
    } catch (error) {
      console.error(`Ошибка загрузки документов для категории ID ${parentId}:`, error);
      if (error.response) {
        console.error(`Данные ошибки от сервера для ID ${parentId}:`, error.response.data);
        console.error(`Статус ошибки для ID ${parentId}:`, error.response.status);
        alert(`Ошибка ${error.response.status} при загрузке списка документов: ${error.response.data?.message || error.response.data || 'Неизвестная ошибка сервера'}`);
      } else if (error.request) {
        console.error(`Запрос отправлен, но ответ не получен для ID ${parentId}:`, error.request);
        alert("Ошибка сети: Не удалось получить ответ от сервера при загрузке документов. Проверьте подключение и доступность API.");
      } else {
        console.error(`Ошибка настройки запроса документов для ID ${parentId}:`, error.message);
        alert("Ошибка при настройке запроса документов: " + error.message);
      }
      setDocuments([]);
    } finally {
      setLoadingTable(false);
    }
  };

  const handleCategorySelect = (category) => {
    console.log("Выбрана категория в списке:", category);
    setSelectedCategory(category);
  };

  // 2. Обработчик клика по строке таблицы документов
  const handleDocumentSelect = (document) => {
    console.log("Выбран документ в таблице:", document);
    setSelectedDocument(document);
  };

  // 3. Обработчик кнопки "Выбрать"
  const handleChooseDocument = () => {
    if (selectedDocument) {
      console.log("Передаём выбранный документ родителю:", selectedDocument);
      // 4. Вызываем проп onSelect, передавая выбранный документ
      if (onSelect) {
        onSelect(selectedDocument);
      }
      // Закрываем модальное окно
      onClose();
    } else {
      alert("Пожалуйста, выберите документ из таблицы.");
    }
  };

      // Стили для ограничения размера модального окна

  return (
    <CModal
      alignment="start"
      size="xl"
      visible={visible}
      onClose={onClose}
      backdrop="static"
    >
      <CModalHeader>
        <CModalTitle>Справочник: Нормативные документы</CModalTitle>
      </CModalHeader>
      <CModalBody>
        {/* Кнопки управления */}
        <div className="mb-3 d-flex justify-content-between align-items-center"> {/* Используем d-flex и justify-content-between */}
          <div>
            <CButton color="primary" size="sm" className="me-2">Добавить</CButton>
            <CButton color="secondary" size="sm" className="me-2">Редактировать</CButton>
            <CButton color="danger" size="sm" className="me-2">Удалить</CButton>
            <CButton color="info" size="sm" className="me-2">Ссылки</CButton>
            <CButton color="warning" size="sm">Термины</CButton>
          </div>
          {/* 5. Кнопка "Выбрать" в правом углу */}
          <CButton
            color="success"
            size="sm"
            onClick={handleChooseDocument}
            disabled={!selectedDocument} // Кнопка активна только если выбран документ
          >
            <CIcon icon={cilCheck} className="me-1" /> {/* Иконка галочки */}
            Выбрать
          </CButton>
        </div>

        <CRow>
          <CCol xs={2} className="border-end">
            <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
              {loadingTree ? (
                <div className="text-center p-3">
                  <CSpinner size="sm" />
                  <div>Загрузка категорий...</div>
                </div>
              ) : rootCategories.length > 0 ? (
                <CListGroup>
                  {rootCategories.map((category) => (
                    <CListGroupItem
                      key={category.Id}
                      action
                      active={selectedCategory && selectedCategory.Id === category.Id}
                      onClick={() => handleCategorySelect(category)}
                      style={{ cursor: 'pointer' }}
                    >
                      {category.Name}
                    </CListGroupItem>
                  ))}
                </CListGroup>
              ) : (
                <div className="text-muted small">Категории не найдены</div>
              )}
            </div>
          </CCol>

          <CCol xs={10}>
            <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
              {loadingTable ? (
                <div className="text-center p-3">
                  <CSpinner size="sm" />
                  <div>Загрузка документов...</div>
                </div>
              ) : (
                <CTable striped bordered hover responsive size="sm">
                  <CTableHead>
                    <CTableRow>
                      <CTableHeaderCell>Наименование</CTableHeaderCell>
                      <CTableHeaderCell>Год ввода в действие</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {documents.length > 0 ? (
                      documents.map((doc) => (
                        // 6. Строка таблицы становится кликабельной и выделяется
                        <CTableRow
                          key={doc.id}
                          // Добавляем класс active, если документ выбран
                          className={selectedDocument && selectedDocument.id === doc.id ? 'table-success' : ''}
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleDocumentSelect(doc)} // Обработчик клика
                        >
                          <CTableDataCell>{doc.name}</CTableDataCell>
                          <CTableDataCell>{doc.year || 'Н/Д'}</CTableDataCell>
                        </CTableRow>
                      ))
                    ) : (
                      <CTableRow>
                        <CTableDataCell colSpan="2" className="text-center">
                          {selectedCategory
                            ? 'Нет документов в выбранной категории'
                            : 'Выберите категорию для отображения документов'}
                        </CTableDataCell>
                      </CTableRow>
                    )}
                  </CTableBody>
                </CTable>
              )}
            </div>
          </CCol>
        </CRow>
      </CModalBody>
    </CModal>
  );
};

export default NormDocumentsDirectory;